import { createSelector } from '@reduxjs/toolkit';
import { getSearchMeta } from './searchSelectors';

const getSubRegions = createSelector(getSearchMeta, (meta) => meta?.counts?.bySubRegion || []);

export const getAvailableSubRegions = createSelector(getSubRegions, (subRegions) =>
  subRegions.map(({ count, region }) => ({ count, name: region.name, type: region.id, id: region.id })),
);
